<template>
  <div class="image">
    <div class="image__responsive" :style="styles.responsive"></div>
    <div v-lazy:background-image="props.src" class="image__image" :style="styles.image"></div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  src: string;
  aspectRatio?: number | string;
  contain?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  aspectRatio: 1,
  contain: false,
});

const _computedAspectRatio = computed(() => Number(props.aspectRatio));
const _aspectStyle = computed(() =>
  _computedAspectRatio.value ? { paddingBottom: (1 / _computedAspectRatio.value) * 100 + '%' } : undefined
);

const _backgroundSizeStyle = computed(() => ({ backgroundSize: props.contain ? 'contain' : 'cover' }));

const styles = computed(() => ({
  responsive: {
    ..._aspectStyle.value,
  },
  image: {
    ..._backgroundSizeStyle.value,
  },
}));
</script>

<style scoped lang="scss">
.image {
  width: 100%;
  position: relative;
  overflow: hidden;
  flex: 1 0 auto;
  max-width: 100%;
  display: flex;

  &__responsive {
    transition: padding-bottom 0.2s cubic-bezier(0.25, 0.8, 0.5, 1);
    flex: 1 0 0;
  }

  &__image {
    background-position: center center;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
